import { CoolbluesChoiceLabel } from '@coolblue-development/next-coolblues-choice-label/client';
import { FilterPagePromoIcon } from '@features/product/typings';

export const PrimaryIcon = ({
  promoIcon
}: {
  promoIcon: { type: FilterPagePromoIcon['type'] } & Partial<Omit<FilterPagePromoIcon, 'type'>>;
}) => {
  if (!promoIcon) {
    return <></>;
  }

  if (
    promoIcon.type === 'CoolbluesChoice' ||
    promoIcon.type === 'CoolbluesGreenChoice' ||
    promoIcon.type === 'Green' ||
    promoIcon.type === 'Normal'
  ) {
    return (
      <CoolbluesChoiceLabel
        variant={
          promoIcon.type === 'CoolbluesGreenChoice' || promoIcon.type === 'Green'
            ? 'green'
            : undefined
        }
      />
    );
  }

  return null;
};
